import React, { Component } from 'react';
import CartWidget from './CartWidget';
import MediaQuery from 'react-responsive';

class Navigation extends Component {

	constructor(){
		super();
		this.handleUpdateCart = this.handleUpdateCart.bind(this);
		this.handleShowCart = this.handleShowCart.bind(this);
	}

	handleUpdateCart(cart){
		this.props.onUpdateCart(cart);
	}

	handleShowCart(){
		this.props.onShowCart();
	}

    render(){
        return(
			<div>
			<MediaQuery query="(min-width: 600px)">
				<div className="vb-nav">

					<ul className="vb-navigation">
					{this.props.navlogo ? 
						<li>
							<a href="./" title="">
								<img className="logo-small" src="./images/logo_intourist.png" width="178" height="70" alt="" />
							</a>
						</li>
					: ''}
						<li><a href="#offers" title="">Offers</a></li>
						<li><a href="#rooms" title="">Rooms</a></li>
						<li><a href="#services" title="">Services</a></li>
						<li><a href="#restaurant" title="">Restoraunt</a></li>
						<li><a href="#events" title="">Event & Meetings</a></li>
						<li><a href="#gallery" title="">Gallery</a></li>
						<li><a href="#contacts" title="">Contacts</a></li>
						<li><a href="#profile" title="">My Profile</a></li>
					</ul>

					<div className="vb-nav-right">
						<div className="vb-hotel-group">
							<a className="vb-hg-a" href="./" title="">
								The hotel group&nbsp;
								<svg width="7" height="5" viewBox="0 0 7 5" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M0.390381 0.945312L3.49976 4.05493L6.60938 0.945312" stroke="white"/>
								</svg>								
							</a>
						</div>
						<div className="vb-cart-language">
							<CartWidget items={this.props.cartItems} 
										onUpdateCart={this.handleUpdateCart}
										onShowCart={this.handleShowCart}
							/>
							<a className="vb-language" href="#en" title="">
								En&nbsp;
								<svg width="7" height="5" viewBox="0 0 7 5" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M0.390625 0.945312L3.5 4.05493L6.60962 0.945312" stroke="white"/>
								</svg>								
							</a>
						</div>
					</div>

				</div>
			</MediaQuery>
		    <MediaQuery query="(max-width: 599px)">
				<div className="vbmobile-home-topblock">
					<div className="vbmobile-top">
						<div className="vbmobile-logo">
							<a href="./" title="">&nbsp;</a>
						</div>
						<div className="vbmobile-callback">
							Callback&nbsp;
							<div className="vb-mobile-iconCallback"></div>					
						</div>
					</div>
					<div className="vbmobile-navigation">
						<div className="vbmobile-bar">
							<button  className="vbmobile-bar-button"></button>
						</div>
						<div className="vbmobile-nav-right">
							<div className="vbmobile-cart-language">
								<CartWidget items={this.props.cartItems} 
											onUpdateCart={this.handleUpdateCart}
											onShowCart={this.handleShowCart}
								/>
								<a className="vb-language" href="#en" title="">
									En&nbsp;
									<svg width="7" height="5" viewBox="0 0 7 5" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M0.390625 0.945312L3.5 4.05493L6.60962 0.945312" stroke="white"/>
									</svg>								
								</a>
							</div>
						</div>
					</div>
				</div>
			</MediaQuery>
			</div>
        )
    }
}

export default Navigation;